import { useEffect, useState } from "react";
import { Stage, Layer } from "react-konva";
import { Group, Line, Rect, Text, Circle } from 'react-konva';
import { handleStageWheel, cursorGrab, handleStageDragMoveJozaiComn, handleStageDragStart, renderHybridPcs, renderPcsComn } from '../../../utils/DiagramParts';
import LoadImage from "../../../commons/LoadImage";
import { Col } from 'reactstrap'
import { getDeviceConfig } from "../../../api/api";
import Spinner from "../../../commons/Spinner";


const ComnOta = (props) => {

    const [scene, setScene] = useState({ width: window.innerWidth, height: window.innerHeight - 150 });
    const [stageScale] = useState(0.50);
    const [isLoading, setIsLoading] = useState(true);
    const authToken = localStorage.getItem('accessToken');
    const [deviceList, setDeviceList] = useState({

        batArr: [
            { device_id: 'PCS 2-1', ip_address: '12.2.2.2', work_status: 0 },
            { device_id: 'PCS 2-2', ip_address: '', work_status: 0 },
            { device_id: 'PCS 2-3', ip_address: '', work_status: 0 },
            { device_id: 'PCS 2-4', ip_address: '', work_status: 0 },
            { device_id: 'PCS 2-5', ip_address: '', work_status: 0 },
            { device_id: 'PCS 2-6', ip_address: '', work_status: 0 },
            { device_id: 'PCS 2-7', ip_address: '', work_status: 0 },
            { device_id: 'PCS 2-8', ip_address: '', work_status: 0 },
            { device_id: 'PCS 2-9', ip_address: '', work_status: 0 },
            { device_id: 'PCS 2-10', ip_address: '', work_status: 0 },
            { device_id: 'PCS 2-11', ip_address: '', work_status: 0 },
            { device_id: 'PCS 2-12', ip_address: '', work_status: 0 },
        ],
        pcsArr: [
            { device_id: 'PCS 3-1', ip_address: '', work_status: 0 },
            { device_id: 'PCS 3-2', ip_address: '', work_status: 0 },
            { device_id: 'PCS 3-3', ip_address: '', work_status: 0 },
            { device_id: 'PCS 3-4', ip_address: '', work_status: 0 },
            { device_id: 'PCS 3-5', ip_address: '', work_status: 0 },
            { device_id: 'PCS 3-6', ip_address: '', work_status: 0 },
            { device_id: 'PCS 3-7', ip_address: '', work_status: 0 },
            { device_id: 'PCS 3-8', ip_address: '', work_status: 0 },
            { device_id: 'PCS 3-9', ip_address: '', work_status: 0 },
            { device_id: 'PCS 3-10', ip_address: '', work_status: 0 },
            { device_id: 'PCS 3-11', ip_address: '', work_status: 0 },
            { device_id: 'PCS 3-12', ip_address: '', work_status: 0 },
        ],
        hybridPcs: [{
            device_id: "PV_50KW_PCS_1", ip_address: '', work_status: 0
        }]

    });

    useEffect(() => {
        if (props.deviceId !== null) {
            const controller = new AbortController();
            const signal = controller.signal;
            const fetchDevices = async (signal) => {
                setIsLoading(true);
                const data = await getDeviceConfig(authToken, props.deviceId, { configType: 'network_config' }, signal);
                if (data.length > 0) {
                    const hybridPcs = data.filter(el => el.device_id.toLowerCase().includes('50'));
                    // const multiMeter = deviceList.filter(el => el.device_id.toLowerCase().includes('meter'));
                    const batArr = data.filter(el => el.device_id.toLowerCase().startsWith('btpcs')
                    ).sort((a, b) => a.device_id.localeCompare(b.device_id, 'en', { numeric: 'true', sensitivity: 'base' }));
                    setScene({ width: window.innerWidth, height: window.innerHeight + batArr.length * 270 });

                    const pcsArr = data.filter(el => el.device_id.toLowerCase().startsWith('pvpcs')
                    ).sort((a, b) => a.device_id.localeCompare(b.device_id, 'en', { numeric: 'true', sensitivity: 'base' }));

                    setDeviceList({ batArr, pcsArr, hybridPcs });
                }
                setIsLoading(false);
            };

            fetchDevices(signal);
            return () => {
                controller.abort();
            };
        }//eslint-disable-next-line
    }, [props.deviceId]);

    return (<>{isLoading ? <Spinner /> :
        <Col style={{ 'height': "80vh" }}>
            <Stage
                id="jozai"
                width={scene.width}
                height={scene.height}
                scaleX={+stageScale}
                scaleY={+stageScale}
                onWheel={handleStageWheel}
                draggable={true}
                onDragStart={handleStageDragStart}
                onDragEnd={cursorGrab}
                onMouseOver={cursorGrab}
                onDragMove={handleStageDragMoveJozaiComn}
                onClick={(e) => console.log(e.target)}
            >
                <Layer>
                    {renderPcsComn([deviceList.batArr[0], deviceList.pcsArr[0], deviceList.batArr[1], deviceList.pcsArr[1]], 950, 235, 'iwaneright')}
                    {renderPcsComn([deviceList.batArr[2], deviceList.pcsArr[2], deviceList.batArr[3], deviceList.pcsArr[3]], 350, 335, 'iwaneleft')}
                    {renderPcsComn([deviceList.batArr[4], deviceList.pcsArr[4], deviceList.batArr[5], deviceList.pcsArr[5]], 950, 420, 'iwaneright')}
                    {renderPcsComn([deviceList.batArr[6], deviceList.pcsArr[6], deviceList.batArr[7], deviceList.pcsArr[7]], 350, 520, 'iwaneleft')}
                    {renderPcsComn([deviceList.batArr[8], deviceList.pcsArr[8], deviceList.batArr[9], deviceList.pcsArr[9]], 950, 600, 'iwaneright')}
                    {renderPcsComn([deviceList.batArr[10], deviceList.pcsArr[10], deviceList.batArr[11], deviceList.pcsArr[11]], 350, 700, 'iwaneleft')}
                    <Group x={1180} y={0}>
                        <Group x={-80} y={345} >

                            {renderHybridPcs(deviceList)}

                        </Group>
                        <Group>
                            {/* ----------------outer dashed line------------- */}
                            <Line stroke="black" strokeWidth={1} points={[100, 100, 100, 660, 990, 660, 990, 100, 100, 100]} dash={[60, 15, 15, 18, 15, 18]} />
                        </Group>
                    </Group>

                    <Group>
                        <Rect x={1300} y={150} width={150} strokeWidth={1} height={480} stroke="black" />
                        <Text x={1350} y={400} text={'    EDS-208 No.2 \n\n (スイッチング HUB)\n\n        8ボ - ト'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} rotation={270} />
                        <Rect x={1520} y={150} width={150} strokeWidth={1} height={480} stroke="black" />
                        <Text x={1550} y={400} text={'    EDS-208 No.1 \n\n (スイッチング HUB)\n\n        8ボ -ト'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} rotation={270} />
                        <Line stroke="#548235" strokeWidth={5} x={1420} y={150} points={[95, 60, 30, 60]} dash={[10, 10]} />
                        <Text x={1450} y={170} text={'LAN'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                        <Text x={1410} y={280} text={'PW'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                        <Line stroke="#548235" strokeWidth={5} x={1420} y={230} points={[55, 60, 30, 60]} />
                        <Line stroke="#548235" strokeWidth={5} x={1475} y={263} points={[1, 1, 1, 30]} />
                        <Text x={1445} y={240} text={'DC 電源'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                    </Group>

                    <Group x={1255} y={5}>

                        {/* -----------Top----------------- */}
                        <LoadImage src="/img/antena.png" x={615} y={-10} height={133 / 3} width={132 / 3} />
                        <Text x={655} y={5} text={'LTE'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                        <Text x={100} y={60} text={'通信機器収納盤'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                        <Text x={625} y={55} text={'外部アンテナ'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                        <Rect x={605} y={35} width={20} strokeWidth={1} height={30} stroke="black" />
                        <Line stroke="#548235" strokeWidth={5} x={615} y={65} points={[1, 1, 1, 70]} />

                        {/* --------------inner rectangle ----------------------------*/}
                        <Rect x={540} y={135} width={150} strokeWidth={1} height={50} stroke="black" />
                        <Text x={540} y={132} text={'        IOG-700 \n\n (モバイルルータ)'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

                        <Rect x={700} y={240} width={170} strokeWidth={1} height={50} stroke="black" />
                        <Text x={695} y={240} text={'SMA DATA MANAGER \n\n EDMM'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

                        <Rect x={550} y={350} width={170} strokeWidth={1} height={50} stroke="black" />
                        <Text x={550} y={350} text={'OpenBlocks IoT VX2 \n\n (SEMS デバイス)'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

                        <Rect x={522} y={450} width={170} strokeWidth={1} height={50} stroke="black" />
                        <Text x={530} y={450} text={'MGate MB3280 \n\n (RS485/LAN変換器)'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />



                        {/* ----------------inner dashed horizontal line------------- */}
                        <Line stroke="#548235" strokeWidth={5} x={385} y={200} points={[315, 60, 30, 60]} dash={[10, 10]} />
                        <Line stroke="#548235" strokeWidth={5} x={375} y={315} points={[170, 60, 30, 60]} dash={[10, 10]} />
                        <Line stroke="#548235" strokeWidth={5} x={375} y={410} points={[149, 60, 30, 60]} dash={[10, 10]} />

                        {/* ------------------text inside dashed line-------------- */}
                        <Text x={630} y={230} text={'LAN'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                        <Text x={580} y={180} text={'LAN'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                        <Text x={500} y={340} text={'LAN'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                        <Text x={420} y={440} text={'LAN'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

                        <Line stroke="#548235" strokeWidth={5} x={568} y={162} points={[10, 20, 10, 100,]} dash={[14, 14]} />
                        {/* <Circle x={575} y={215} radius={10} stroke="black" strokeWidth={1} dash={[20, 20]} rotation={190} /> */}
                        {/* <Line stroke="black" strokeWidth={1} x={577} y={223} points={[1, 1, 1, 30,]} dash={[17, 17]} /> */}
                        <Circle x={573} y={260} radius={10} stroke="#548235" strokeWidth={5} dash={[20, 20]} rotation={190} />
                        <Line stroke="#548235" strokeWidth={5} x={577} y={268} points={[1, 1, 1, 83]} dash={[17, 17]} />
                    </Group>
                    <Group x={1250} y={5}>
                        {/* ----------------lower line---------------- */}
                        <Line stroke="#548235" strokeWidth={5} x={560} y={491} points={[10, 10, 10, 80,]} dash={[10, 10]} />
                        <Circle x={565} y={585} radius={10} stroke="#548235" strokeWidth={5} dash={[20, 20]} rotation={190} />
                        <Line stroke="#548235" strokeWidth={5} x={569} y={593} points={[1, 1, 1, 150]} dash={[15, 15]} />


                        {/* -----------------Lower outer part---------- */}
                        <Rect x={390} y={700} width={250} strokeWidth={1} height={50} stroke="black" fill={"#d9e6ff"} />
                        <Text x={410} y={700} text={'XM2-110-995-M00-111\n\n (主幹用マルチメータ ー)'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                        <Text x={580} y={670} text={'RS485'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

                    </Group>
                    <Group x={1100} y={20}>

                        <Text x={200} y={145} text={'2'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                        <Text x={200} y={220} text={'3'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                        <Text x={200} y={395} text={'4'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                        <Text x={200} y={580} text={'5'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

                        <Text x={325} y={175} text={'1'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                        <Text x={415} y={175} text={'3'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                        <Text x={545} y={230} text={'1'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                        <Text x={545} y={345} text={'2'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                        <Text x={545} y={440} text={'4'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

                    </Group>


                </Layer>
            </Stage>
        </Col>
    }
    </>
    );

};

export default ComnOta;
